<div class="autocomplete-input_inner-container">
    <input
        type="text"
        autocomplete="off"
        class="autocomplete-input_input"
        [deliverableAutocomplete]="autocompleteConfig"
        [autocompleteReferenceElement]="elementRef.nativeElement"
        [disabled]="isDisabled"
        [placeholder]="placeholder || ''"
        (focusin)="onInnerFocus()"
        (focusout)="onInnerBlur()">

    <div class="autocomplete-input_static">
        <span class="autocomplete-input_static_symbol">{{displaySymbol?.symbol}} </span>

        @if (displaySymbol?.exchange) {
            <span class="autocomplete-input_static_exchange">{{displaySymbol?.exchange}}</span>
        }
    </div>

    @if (isClearBtnVisible) {
        <svg class="autocomplete-input_clear-icon"
             (click)="clear()">
            <use xlink:href="#small-close"></use>
        </svg>
    }

    @if (asSelectInput) {
        <svg class="autocomplete-input_toggle-menu-icon"
             (click)="innerValueAccessor.openSelectDropdown()">
            <use xlink:href="#chevron-down"></use>
        </svg>
    }
</div>
